import { Component, OnInit } from '@angular/core';
import { MasterDataService } from './../../services/master-data.service';
import { NgModel } from '@angular/forms';
import * as moment from 'moment';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-empanelment-report',
  templateUrl: './empanelment-report.component.html',
  styleUrls: ['./empanelment-report.component.css'],
})
export class EmpanelmentReportComponent implements OnInit {
  selectedBranch;
  branchList;
  empanelmentRoleList;
  selectedEmpanelmentRole;
  selectedServiceVertical;
  isRoleSelected = false;
  isServiceVerticalSelected = false;
  selectedCurrentDate;
  empanelmentReportList = [];
  serviceVerticalList;
  isBranchSelected = false;
  userRole;
  accessResponse: any;

  constructor(private masterDataService: MasterDataService, private commonMessageService: CommonMessageService,
    private branchFilterService: BranchFilterService
  ) { }

  ngOnInit(): void {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.selectedBranch = '';
    this.getBranchList();
    this.loadServiceVerticals();
    // this.getEmpanelmentRoleList();
  }

  loadServiceVerticals() {
    this.masterDataService.getServiceVerticalList()
      .subscribe(res => {
        console.log(res);
        this.serviceVerticalList = res;
      });
  }

  getBranchList() {
    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchList = res;
    // });
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });
  }

  getEmpanelmentRoleList() {
    this.masterDataService.getRoles().subscribe((res) => {
      console.log('empanelment List', res);
      this.empanelmentRoleList = res;
    });
  }

  onBranchSelect() {
    console.log('insid branch select');
    this.empanelmentReportList = [];
    this.selectedCurrentDate = '';
    this.showExportToExcelButton = false;
    this.selectedEmpanelmentRole = [];
    this.getEmpanelmentRoleList();
  }

  onRoleSelect() {
    this.selectedCurrentDate = '';
    this.showExportToExcelButton = false;
    this.empanelmentReportList = [];
  }

  selectAllEmpanelmentRole(select: NgModel, values) {
    this.selectAll(select, values, this.isRoleSelected, false);
    this.isRoleSelected = !this.isRoleSelected;
  }

  selectAllServiceVertical(select: NgModel, values) {
    this.selectAll(select, values, this.isServiceVerticalSelected, false);
    this.isServiceVerticalSelected = !this.isServiceVerticalSelected;
  }

  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected, false);
    this.isBranchSelected = !this.isBranchSelected;
  }

  selectAll(select: NgModel, values, isSelected, isId) {
    this.selectedCurrentDate = '';
    this.showExportToExcelButton = false;
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  formatDate;
  selectedEmpanelmentRoleId;
  selectedServiceVerticalId;
  branchId;
  showExportToExcelButton: boolean;
  onViewReport() {
    console.log(this.selectedCurrentDate);
    if (
      this.selectedBranch == '' ||
      this.selectedBranch == undefined ||
      this.selectedCurrentDate == '' ||
      this.selectedCurrentDate == undefined ||
      this.selectedServiceVertical == undefined ||
      this.selectedServiceVertical.length === 0 ||
      this.selectedEmpanelmentRole.length === 0 ||
      this.selectedEmpanelmentRole == undefined

    ) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please choose the values before pressing report');
      return;
    }
    var entryDate1 = new Date(
      this.selectedCurrentDate.year +
      '-' +
      this.selectedCurrentDate.month +
      '-' +
      this.selectedCurrentDate.day
    );
    console.log('entrydate', entryDate1);
    this.formatDate = moment(entryDate1).format('YYYY-MM-DD');
    console.log('format date', this.formatDate);

    this.selectedEmpanelmentRoleId = this.selectedEmpanelmentRole.map(
      ({ id }) => id
    );

    this.selectedServiceVerticalId = this.selectedServiceVertical.map(
      ({ id }) => id
    );

    console.log('select role', this.selectedEmpanelmentRoleId);
    this.branchId = this.selectedBranch.map(({ id }) => id);
    console.log('branch id', this.branchId);
    this.masterDataService
      .getEmpanelmentRoleReport(this.branchId, this.selectedEmpanelmentRoleId, this.formatDate, this.selectedServiceVerticalId)
      .subscribe((res: any) => {
        console.log('view report empanelment', res);
        if (res != null) {
          this.empanelmentReportList = res.roles;
          console.log('view report empanelment list', this.empanelmentReportList);
          this.showExportToExcelButton = true;
        } else {
          this.commonMessageService.swalAlertWithoutIcon('', "No Record Found");
          this.showExportToExcelButton = false;
        }
      });
  }

  exportToExcelClick() {


    this.masterDataService.getEmpanelmentRoleReportExcel(this.branchId, this.selectedEmpanelmentRoleId, this.formatDate, this.selectedServiceVerticalId).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "EmpanelmentReport.xlsx";
      link.click();
    });
  }

  exportToPDFClick() {
    console.log('exportToPDFList', this.empanelmentReportList);
    var docDefinition = {
      info: { title: 'Empanelment Report' },
      pageOrientation: 'landscape',
      content: [
      ],
    };

    docDefinition.content.push({ text: 'P G BHAGWAT LLP, Chartered Accountants', fontSize: 14, bold: true, alignment: 'center' });
    docDefinition.content.push({ text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', alignment: 'center' });
    docDefinition.content.push({ text: 'Empanelment Report', fontSize: 14, bold: true, alignment: 'center', margin: [0, 10, 0, 5] });

    for (let i = 0; i < this.empanelmentReportList.length; i++) {
      docDefinition.content.push(' ');
      docDefinition.content.push({ text: `${this.empanelmentReportList[i].role}`, fontSize: 12, bold: true, margin: [0, 0, 0, 5] });

      if (this.empanelmentReportList[i].role == 'Article') {
        docDefinition.content.push({
          table: {
            headerRows: 1,
            widths: [23, 50, 30, 'auto', 'auto', 30, 'auto', 'auto', 'auto', 'auto', 67, 50, 40, '*'],
            body: [
              [{ text: 'Sr.No.	', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Article Name', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Gender	', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Firm Joining Date', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'DOB', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'ICAI Registration No.', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Type Of Article', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Reporting Partner', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Registered Partner	', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Contact No.', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Email Id	', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Articleship End Date	', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Branch Name', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Service Vertical', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }],
              ...this.empanelmentReportList[i].details.map((res, index) => [{ text: `${index + 1}` }, { text: `${res.firstName} ${(res.middleName == null ? '' : res.middleName)} ${res.lastName}` }, { text: res.gender }, { text: `${moment(res.joiningDate).format('DD-MM-YYYY')}` }, { text: `${moment(res.dateOfBirth).format('DD-MM-YYYY')}` }, { text: `${(res.icaiRegistrationNumber == null ? '' : res.icaiRegistrationNumber)}` }, { text: `${(res.articleType == null ? '' : res.articleType)}` }, { text: `${res.reportingPFName} ${(res.reportingPMName == null ? '' : res.reportingPMName)} ${res.reportingPLName}` }, { text: `${(res.regPartnerFName == null ? '' : res.regPartnerFName)} ${(res.regPartnerMName == null ? '' : res.regPartnerMName)} ${(res.regPartnerLName == null ? '' : res.regPartnerLName)}` }, { text: res.officalMobileNumber }, { text: res.email }, { text: `${(res.articleshipEndDate == null ? '' : moment(res.articleshipEndDate).format('DD-MM-YYYY'))}` }, { text: res.branch }, { text: res.serviceVertical ?? '' }]),
            ]
          }
        });
      } else if (this.empanelmentReportList[i].role == 'Senior Manager' || this.empanelmentReportList[i].role == 'Manager' || this.empanelmentReportList[i].role == 'Partner' ||
        this.empanelmentReportList[i].role == 'Principal' || this.empanelmentReportList[i].role == 'Director' || this.empanelmentReportList[i].role == 'Consultant') {
        docDefinition.content.push({
          table: {
            headerRows: 1,
            widths: [25, '*', '*', '*', '*', '*', '*', '*', '*', '*', 70, 40, '*'],
            body: [
              [{ text: 'Sr.No.	', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Employee Name', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Gender	', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Firm Joining Date', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'DOB', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Date Of Membership No.	', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Membership No.	', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'No. of Years of Experience	', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Certification', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Contact No.', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Email Id	', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Branch Name', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Service Vertical', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }],
              ...this.empanelmentReportList[i].details.map((res, index) => [{ text: `${index + 1}` },
              { text: `${res.firstName} ${res.middleName} ${res.lastName}` },
              { text: res.gender },
              { text: `${moment(res.joiningDate).format('DD-MM-YYYY')}` },
              { text: `${moment(res.dateOfBirth).format('DD-MM-YYYY')}` },
              { text: `${moment(res.dateOfMembershipNumber).format('DD-MM-YYYY')}` },
              { text: `${res.membershipNumber}` },
              { text: `${res.experience}` },
              { text: res.certifications },
              { text: res.officalMobileNumber },
              { text: res.email },
              { text: res.branch },
              { text: res.serviceVertical ?? '' }]),
              // [{ text: 'Total Available Articles', bold: true, fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: `${totalAvailableArticle}`, fillColor: '#e1f4f7' }]
            ]
          }
        });
      } else if (this.empanelmentReportList[i].role == 'Assistant' || this.empanelmentReportList[i].role == 'Account Executive' || this.empanelmentReportList[i].role == 'HR Assistant' ||
        this.empanelmentReportList[i].role == 'HR Executive' || this.empanelmentReportList[i].role == 'HR Manager' || this.empanelmentReportList[i].role == 'Salaried Partner' || this.empanelmentReportList[i].role == 'Office Assistant' || this.empanelmentReportList[i].role == 'Associate') {
        docDefinition.content.push({
          table: {
            headerRows: 1,
            widths: [25, 100, 30, '*', '*', '*', '*', 200, 40, '*'],
            body: [
              [{ text: 'Sr.No.	', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Employee Name', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Gender	', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Firm Joining Date', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'DOB', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'No. of Years of Experience', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Contact No.	', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: 'Email Id	', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: '	Branch Name', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
              { text: '	Service Vertical', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }],
              ...this.empanelmentReportList[i].details.map((res, index) => [{ text: `${index + 1}` }, { text: `${res.firstName} ${res.middleName} ${res.lastName}` }, { text: res.gender }, { text: `${moment(res.joiningDate).format('DD-MM-YYYY')}` }, { text: `${moment(res.dateOfBirth).format('DD-MM-YYYY')}` }, { text: `${res.experience}` }, { text: `${res.officalMobileNumber}` }, { text: res.email }, { text: res.branch }, { text: res.serviceVertical ?? '' }]),
              // [{ text: 'Total Available Articles', bold: true, fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: `${totalAvailableArticle}`, fillColor: '#e1f4f7' }]
            ]
          }
        });
      }
    }
    pdfMake.createPdf(docDefinition).download('EmpanelmentReport.pdf');
  }
}
